import React from 'react';
import { useContextTranslation } from '@core/i18n';
import { Trans } from '@core/react-i18next-lazy';
import { BrandLink, BrandLogo, Container } from './FireworkBrand.styles';
const PROMO_URL = 'https://firework.com/video-solutions-for-entrepreneurs/?utm_source=website&utm_content=widget&utm_campaign=poweredbyfirework';
/**
 * Firework Brand in modals
 */
export const FireworkBrand = ({ url = PROMO_URL }) => {
    const { t } = useContextTranslation();
    return (<BrandLink href={url} target="_blank" rel="noreferrer" aria-label={t('Powered by {{firework}}', {
            firework: 'Firework', //we don't want our name translated
        })} onClick={(e) => {
            e.stopPropagation();
        }}>
      <Container className="cy-made-in-fw">
        <Trans i18nKey="Powered by <0>Firework</0>" default="Powered by <0>Firework</0>" components={[
            <BrandLogo key="0" aria-hidden className="cy-fwlogo" label={t('Firework logo')}/>,
        ]}/>
      </Container>
    </BrandLink>);
};
